(function ($) {
  'use strict';

  var initMainMenu = function () {
    var $menuItems = $('.cc--main-menu ul.m--menu > li.menu-item--expanded');
    var $arrowToggle = $('.desktop-nav ul li .arrow-toggle');

    ally.style.focusWithin();

    $menuItems.on('click', function () {
      $menuItems.removeClass('ally-focus-within');

      if (whatInput.ask() === 'touch') {
        $(this).addClass('ally-focus-within');
      }
    });

    $arrowToggle.focus(function () {
      $(this).parent().next().css('display', 'flex');
    });
  };

  window.DP.behaviors.mainMenu = {
    attach: function (context) {
      once('mainMenu', '.cc--main-menu', context)
        .forEach(() => {
          initMainMenu.apply();
        });
      // $(context).find('.cc--main-menu').once('mainMenu').each(function () {
      //   initMainMenu.apply();
      // });
    }
  };

})(jQuery);
